import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

// components
import CaretLeftIcon from '@icons/CaretLeftIcon';
import CaretRightIcon from '@icons/CaretRightIcon';

// functionality
import colors from '@general/colors';
import { BodyMedium, LabelSmall } from '@react/styledComponents';

const ComponentContainerStyled = styled.div`
    align-items: center;
    background-color: ${colors.ultraLightGray};
    display: flex;
    justify-content: space-between;
    padding: 10px 24px;
`;

const LinkForIconStyled = styled.a`
    display: flex;
`;

const PlaceholderDivStyled = styled.div`
    width: 16px;
`;

const StepperNavMobile = ({ activeIndex = 0, steps }) => {
    const history = useHistory();
    const previousHref = steps[activeIndex - 1]?.href;
    const nextHref = steps[activeIndex + 1]?.href;

    return (
        <ComponentContainerStyled>
            {activeIndex === 0 && <PlaceholderDivStyled />}
            {activeIndex > 0 && (
                <LinkForIconStyled
                    href={previousHref}
                    onClick={e => {
                        e.preventDefault();
                        history.push(previousHref);
                    }}
                >
                    <CaretLeftIcon color={colors.mediumGray} />
                </LinkForIconStyled>
            )}

            <div className="text-center">
                <LabelSmall className="text-medium-gray">
                    Step {activeIndex + 1} of {steps.length}
                </LabelSmall>
                <BodyMedium>{steps[activeIndex].label}</BodyMedium>
            </div>

            {activeIndex === steps.length - 1 && <PlaceholderDivStyled />}
            {activeIndex < steps.length - 1 && (
                <LinkForIconStyled
                    href={nextHref}
                    onClick={e => {
                        e.preventDefault();
                        history.push(nextHref);
                    }}
                >
                    <CaretRightIcon color={colors.mediumGray} />
                </LinkForIconStyled>
            )}
        </ComponentContainerStyled>
    );
};

StepperNavMobile.propTypes = {
    activeIndex: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default StepperNavMobile;
